module.exports = __webpack_public_path__ + "static/media/calender.426e4b89.svg";